<template>
  <div id="application-content">
    <tool-bar :name="name"></tool-bar>
    <trackings></trackings>
  </div>
</template>

<script>
  import ToolBar from '@/components/User/Layout/Toolbar'
  import Trackings from '@/components/User/Tracking/Trackings'

  export default {
    name: "Tracking",
    components: {
      Trackings,
      ToolBar
    },
    data () {
      return {
        name: 'Track a Package'
      }
    }
  }
</script>

